<template>
  <div>

      <b-modal
          id="tour-booking-modal"
          :title="local_modal_title"
          v-model="modal_show"
          size="lg"
          button-size="lg"
          scrollable
          centered
          @hide="handleHide"
      >
        <div class="box">
          <div class="box-content modal-tour-info">
            <div class="d-flex">
              <div class="modal--tour-header-icon"></div>
              <div>
                  <div class="h2-like modal-tour-info--header">{{title}}</div>
              </div>
              <div class="collapse--opener collapse--opener--green"
                   @click="show_full_info = !show_full_info"
              ></div>
            </div>

            <transition name="fade-simple">
                <b-row v-if="show_full_info">
                    <b-col md="12"><hr></b-col>
                    <b-col md="4" sm="12">
                        <div class="form-group">
                          <label>Туристы</label>
                          <div>{{tourists_humanized}}</div>
                        </div>
                    </b-col>
                    <b-col md="4" sm="6">
                        <div class="form-group">
                          <label>Длительность</label>
                          <div>{{days}}</div>
                        </div>
                    </b-col>
                    <b-col md="4" sm="6">
                        <div class="form-group" v-if="date">
                          <label>Отправление</label>
                          <div>{{date}}</div>
                        </div>
                    </b-col>
                </b-row>
            </transition>

            <transition name="fade-simple">
                <div class="combinations" v-if="show_full_info">
                    <tour-placement-combination-item v-for="(combination, i) in combinations"
                                                     :combination="combination.combo"
                                                     :discount="discount"
                                                     :discount_type="discount_type"
                                                     :index="i"
                                                     :readonly="true"
                    />
                </div>
            </transition>
            <b-row v-if="full_price > 0">
              <b-col md="12"><hr></b-col>
              <b-col md="6">
                <div id="modal-full-price" class="d-inline-flex">
                  <b>
                    <CombinationPrice
                        :positive_only="true"
                        :price="full_price"
                        :discount="discount_precalc"
                        :discount_type="discount_type"
                        direction="row"
                        pre_text="Итого:"
                        size="big"
                    ></CombinationPrice>

                  </b>
                </div>
                <b-tooltip target="modal-full-price" placement="right" triggers="hover" v-if="course && (original_price !== full_price)">
                  {{original_price}}
                </b-tooltip>
              </b-col>
            </b-row>

          </div>
        </div>
        <template v-if="is_saved">
          <span v-html="local_modal_thanks"></span>
        </template>
        <b-alert id="tour-booking-error" variant="danger" show v-if="submit_error">{{ submit_error }}</b-alert>
        <form ref="form" @submit.stop.prevent="handleSubmit" :class="form_css" v-if="is_filling || is_sending">
          <b-row>
            <b-col md="6">
                  <b-form-group
                      :state="nameState"
                      label="Имя"
                      label-for="name-input"
                      invalid-feedback="Обязательное поле"
                  >
                    <b-form-input
                        id="name-input"
                        v-model="name"
                        :state="nameState"
                        required
                    ></b-form-input>

                  </b-form-group>
            </b-col>
            <b-col md="6" class="hide-on-mobile">
                  <b-form-group
                      :state="secondNameState"
                      label="Фамилия"
                      label-for="second-name-input"
                      invalid-feedback="Обязательное поле"
                  >
                    <b-form-input
                        id="second-name-input"
                        v-model="secondName"
                        :state="secondNameState"
                        required
                    ></b-form-input>
                  </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
                  <b-form-group
                      :state="phoneState"
                      label="Телефон"
                      label-for="phone-input"
                      invalid-feedback="Обязательное поле"
                  >
                    <b-form-input
                        id="phone-input"
                        v-model="phone"
                        :state="phoneState"
                        required
                    ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col md="6" class="hide-on-mobile">
                  <b-form-group
                      :state="emailState"
                      label="email"
                      label-for="email-input"
                      invalid-feedback="Обязательное поле"
                  >
                    <b-form-input
                        id="email-input"
                        v-model="email"
                        :state="emailState"
                        class="border-radius-bl-0"
                        required
                    ></b-form-input>
                    <b-form-checkbox
                        id="checkbox-1"
                        v-model="want_emails"
                        name="checkbox-1"
                        :value="true"
                        :unchecked-value="false"
                    >Подписаться на спецпредложения</b-form-checkbox>
                  </b-form-group>
            </b-col>
          </b-row>
          <b-row class="hide-on-mobile">
            <b-col>
              <b-form-group
                  class="mb-3"
                  label="Комментарий"
                  label-for="description-textarea"
              >
                <b-form-textarea
                    id="description-textarea"
                    v-model="description"
                    placeholder="Ваш комментарий к заказу"
                    rows="3"
                    no-resize
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
        </form>
        <template v-slot:modal-footer>

            <div class="modal-footer--left-wrapper">
              <b-form-checkbox
                v-if="!is_saved"
                id="checkbox-2"
                v-model="apply_policy"
                name="checkbox-2"
                :value="true"
                :unchecked-value="false">
                <small class="float-left" v-if="!is_saved">
                  Я принимаю
                  <a data-toggle="modal" data-target="#SiteRulesModal" href="#">Пользовательское соглашение</a>
                  и подтверждаю, что ознакомлен и согласен с
                  <a data-toggle="modal" data-target="#UserPolicyModal" href="#">политикой конфиденциальности</a>
                  этого сайта.
                </small>
              </b-form-checkbox>  
            </div>
            <div class="modal-footer--right-wrapper">
              <b-button
                  v-if="!is_saved"
                  id="submit-btn"
                  :variant="submit_btn_style"
                  size="lg"
                  class="btn-block"
                  @click="handleOk"
              >
                {{ local_modal_btn }}
              </b-button>
              <b-tooltip 
                target="submit-btn"
                v-if="!apply_policy" 
                triggers="hover">
                Необходимо принять пользовательское соглашение и политику конфиденциальности
              </b-tooltip>
              <b-button
                  v-if="is_saved"
                  variant="info"
                  size="lg"
                  class="btn-block"
                  @click="handleOk"
              >
                Закрыть
              </b-button>
            </div>
        </template>
      </b-modal>
    <b-row align-h="end">
      <b-col md="12" lg="12" xl="5">
        <div id="form-full-price" class="d-inline-flex">
          <b>
            <CombinationPrice
                positive_only
                :price="full_price"
                :discount="discount_precalc"
                :discount_type="discount_type"
                direction="row"
                pre_text="Итого:"
                size="big"
            ></CombinationPrice>

          </b>
        </div>
      </b-col>
      <b-col md="12" lg="12" xl="7">
        <b-row align-h="end">
          <b-col md="12" lg="12" xl="6" v-if="show_order_btn">
            <HiddenForm
                ref="preorder_form"
                url="/agent/orders"
                :form_data="composed_form_data"
                field_base="order"
            />
            <b-button variant="secondary" class="btn-block btn-gradient" @click="go_to_new_preorder">Оформить заказ</b-button>
          </b-col>
          <b-col md="12" lg="12" xl="6" v-if="show_preorder_btn">
            <b-button v-b-modal="'tour-booking-modal'" variant="primary" class="btn-block btn-gradient" @click="open_modal">Отправить заявку</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import TourPlacementCombinationItem from "./TourPlacementCombinationItem";
import { pluralize, is_empty, humanized_tourists } from "../../../components/shared/helpers";
import CombinationPrice from "./CombinationPrice";
import moment from "moment";
import HiddenForm from "./HiddenForm";

export default{
  components: {HiddenForm, CombinationPrice, TourPlacementCombinationItem},
  props:{
    tourists: Object,
    combinations: Array,
    tour: Object,
    tour_date: Object,
    course: Number,
    currency_name: String,
    one_day_price: [Number, Boolean],
    modal_title: [String, null],
    modal_thanks: [String, null],
    modal_btn: [String, null],
    role: {
      type: String,
      default: 'guest',
    },
  },
  data() {
    return {
      modal_state: 'filling',
      submit_error: null,
      modal_show: false,
      show_full_info: false,
      name: '',
      secondName: '',
      email: '',
      want_emails: false,
      apply_policy: false,
      phone: '',
      description: '',
      nameState: null,
      secondNameState: null,
      emailState: null,
      phoneState: null,
      course: null,
      currency_name: null,
      hidden_form_data: {},
      default_title: 'Заявка на покупку тура',
      default_btn: 'Отправить заявку',
      default_thanks: '<div class="h1-like">Заявка успешно отправлена!</div>' +
                      '<p>Спасибо за заказ. Мы свяжемся с вами в ближайшее время.</p>' +
                      '<p><b>Режим работы:</b> с понедельника по пятницу с 10 до 19.00. Суббота и Воскресенье - выходные.</p>',
    }
  },
  computed:{
    person_quantity(){
      let q = 0;
      if ( this.tourists && this.tourists.adults ) {
        q = this.tourists.adults;
        if (this.tourists.kids) q += this.tourists.kids.length;
      }
      return q;
    },
    discount_precalc(){
      if (this.discount_type == 'fixed_value') {
        return this.discount * this.person_quantity;
      } else {
        return this.discount;
      }
    },
    discount(){
      return this.tour_date.attributes ? this.tour_date.attributes.discount : 0;
    },
    discount_type(){
      return this.tour_date.attributes ? this.tour_date.attributes.discount_type : 'no_discount';
    },
    full_price(){
      let price = this.one_day_price ? this.one_day_price : _.sum(_.map(this.combinations, 'combo.price'));
      return price;
    },
    original_price(){
      if (this.course == null) return null;
      return `${Math.round(this.full_price / this.course)} ${this.currency_name}`;
    },
    show_order_btn(){
      return (this.role === 'agent') && ((this.combinations.length > 0) || this.tour.one_day);
    },
    show_preorder_btn(){
      return this.role !== 'agent';
    },
    is_name_valid(){
      return (this.name.length >= 2)
    },
    is_phone_valid(){
      return (this.phone.length >= 10)
    },
    is_filling(){
      return this.modal_state === 'filling'
    },
    is_sending(){
      return this.modal_state === 'sending'
    },
    is_saved(){
      return this.modal_state === 'saved'
    },
    form_css(){
      return this.is_sending ? 'modal-content-form muted-form' : 'modal-content-form'
    },
    title(){
      return this.tour ? this.tour.title : '-'
    },
    local_modal_title(){
      return is_empty(this.modal_title) ? this.default_title : this.modal_title;
    },
    local_modal_thanks(){
      return is_empty(this.modal_thanks) ? this.default_thanks : this.modal_thanks;
    },
    local_modal_btn(){
      return is_empty(this.modal_btn) ? this.default_btn : this.modal_btn;
    },
    submit_btn_style(){
      return this.apply_policy ? 'primary' : 'disabled' ;
    },
    date(){
      return (this.tour_date &&  this.tour_date.attributes) ?
          moment(this.tour_date.attributes.date).format('LL') :
          false
    },
    days(){
      return (this.tour) ? `${this.tour.days} ${pluralize(this.tour.days, 'день', 'дня', 'дней')}` : false
    },
    tourists_humanized(){
      return (this.tourists) ? humanized_tourists(this.tourists.adults, this.tourists.kids) : false
    },
    composed_form_data() {
      // Preparing data for sending to server
      return {
        order:{
          tour_id:      this.tour.id,
          tour_date_id: this.tour_date.id,
        },
        booking:{
          tour_id:      this.tour.id,
          tour_date_id: this.tour_date.id,
          adults:       this.tourists.adults,
          kids:         this.tourists.kids ? this.tourists.kids.length    : 0,
          ages:     this.tourists.kids ? this.tourists.kids : [],
        },
        placements: this.combinations_to_links(this.combinations),
      }
    },
    composed_ajax_data(){
      // Preparing data for sending to server
      return {
        preorder: {
          name:         this.name,
          second_name:  this.second_name,
          phone:        this.phone,
          email:        this.email,
          want_emails:  this.want_emails,
          description:  this.description,
          tour_id:      this.tour.id,
          tour_date_id: this.tour_date.id,
          adults:       this.tourists.adults,
          kids:         this.tourists.kids ? this.tourists.kids.length    : 0,
          kid_ages:     this.tourists.kids ? this.tourists.kids.join(',') : '',
          price:        this.full_price,
          combinations: this.combinations,
        },
        // combinations: this.combinations,
      }
    },
  },
  // beforeMount() {
  //   this.get_course();
  // },
  methods:{
    combinations_to_links(combinations){
      let placement_price_links = [];
      _.each(combinations, (combination) => {
        _.each(combination.combo.placements, (el) => {
          placement_price_links.push(
            {
              hotel_group_id:          combination.group_id,
              tour_placement_price_id: el.placement.id,
              quantity:                el.quantity,
              price:                   el.placement.attributes.price,
            }
          );
        })
      });
      return placement_price_links;
    },
    go_to_new_preorder(){
      // this.hidden_form_data = this.composed_form_data.preorder;
      this.$refs.preorder_form.$refs.form.submit();
    },
    open_modal(){
      this.$set(this, 'modal_show', true);
      if (typeof ym !== 'undefined') ym(9791653, 'reachGoal', 'ONLINE-ORDER');
      this.fb_track('InitiateCheckout');
      this.vk_track('Open_webform');
    },
    fb_track(event){
      if (typeof fbq !== 'undefined' && this.role !== 'agent' ) fbq('track', event);
    },
    vk_track(event){
      if (typeof _tmr !== 'undefined' && this.role !== 'agent' ) {
        _tmr.push({type: 'reachGoal', id: 3297236, goal: event});
      }
    },
    checkFormValidity() {
      const valid = this.form_validation();
      this.nameState = valid.name
      this.phoneState = valid.phone
      return (valid.name && valid.phone)
    },
    resetModal() {
      // this.name = ''
      // this.nameState = null
    },
    form_validation(){
      return {
        name: this.is_name_valid,
        phone: this.is_phone_valid,
      }
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      if (this.is_saved) {
        this.close_modal();
      } else {
        if (this.apply_policy) {
          this.fb_track('Lead');
          this.vk_track('Send_webform');
          this.handleSubmit()
        }
      }
    },
    handleHide(bvModalEvt) {
      // console.log('HIDE HANDLE!')
      // Prevent modal from closing
      // bvModalEvt.preventDefault()
      // Trigger submit handler
      this.modal_state = 'filling';
      this.submit_error = null;
      this.show_full_info = false;
      this.nameState = null;
      this.secondNameState = null;
      this.emailState = null;
      this.phoneState = null;


    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity() || this.is_saved) {
        return
      }
      this.modal_state = 'sending';
      this.submit_error = null;
      let vc = this;
      // Request
      $.ajax({
        url: '/preorders',
        data: this.composed_ajax_data,
        dataType: 'json',
        type: 'POST'
      }).done(function(data){
        console.error("Preorder posted successfully.", data);
        vc.modal_state = 'saved';
        vc.apply_policy = false;
        if (typeof ym !== 'undefined') ym(9791653, 'reachGoal', 'SEND-ORDER');
      }).fail(function(jXHR, error){
        // Введённые данные остаются в форме — заявку можно отправить повторно.
        vc.modal_state = 'filling';
        if (jXHR.status === 429) {
          vc.submit_error = 'Слишком много заявок, попробуйте через несколько минут или позвоните нам.';
        } else {
          alert('Ошибка сервера! Попробуйте отправить заявку позже или позвоните по телефону.')
        }
        console.error("Post preorder error.", jXHR, error);
      });


    },

    // Hide the modal manually
    close_modal(){
      this.$nextTick(() => {
        this.$bvModal.hide('tour-booking-modal')
      })
    },
    // get_course(){
    //   let vc = this;
    //   // Request
    //   $.ajax({
    //     url: '/api/v1/get_current_course',
    //     data: {currency_id: this.tour.currency_id},
    //     dataType: 'json',
    //     type: 'GET'
    //   }).done(function(data){
    //     console.log("current course.", data);
    //     vc.$set(vc, 'course', data.course);
    //     vc.$set(vc, 'currency_name', data.currency_name);
    //   }).fail(function(jXHR, error){
    //     console.error("get course error.", jXHR, error);
    //   });
    // },
  }
}
</script>

<style>
.fade-simple-enter-active, .fade-simple-leave-active {
  transition: all .5s;
  max-height: 1000px;
}
.fade-simple-enter, .fade-simple-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  max-height: 0;
}
</style>
